import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { MsalInterceptor } from '@azure/msal-angular';
import { Observable } from 'rxjs';

@Injectable()
export class PaceMsalOfflineCapableInterceptor extends MsalInterceptor implements HttpInterceptor {
    public override intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (navigator.onLine) {
            return super.intercept(req, next);
        } else {
            return next.handle(req);
        }
    }
}
